import { ExhibitionListItem } from './ExhibitionListItem'
import { useExhibitions, ExhibitionWithWorks } from '../lib/apiClient'

export const ExhibitionList: React.FC = () => {
  const {
    data: exhibitions,
    isLoading,
    isError,
  } = useExhibitions(false)
  return (
    <div>
      {isLoading && <p>Loading...</p>}
      {isError && <p>Error!</p>}
      {exhibitions?.length === 0 && <p>No current exhibitions.</p>}
      {
        exhibitions?.map((e: ExhibitionWithWorks) => (
          <ExhibitionListItem key={e.id} exhibition={e} showImage />
        ))
      }
    </div>
  )
}
